import { css } from 'styled-components'

export const MEETING_ROOM_MODAL_WIDTH = '800px'
export const MEETING_ROOM_DETAIL_MODAL_HEIGHT = '600px'
export const MEETING_ROOM_EDIT_MODAL_HEIGHT = '641px'

export const createMeetingRoomModalDialogStyles = (
  width: string = MEETING_ROOM_MODAL_WIDTH,
  height?: string
) => css`
  .modal-dialog {
    max-width: ${width};
    width: ${width};
    margin: 1.75rem auto;

    ${height
      ? `
      height: ${height};
      max-height: ${height};
    `
      : ''}
  }

  .modal-content {
    ${height
      ? `
      height: 100%;
      max-height: ${height};
      display: flex;
      flex-direction: column;
    `
      : ''}
  }

  @media (max-width: 839px) {
    .modal-dialog {
      max-width: calc(100vw - 24px);
      width: calc(100vw - 24px);
      height: auto;
      max-height: calc(100vh - 48px);
      margin: 12px auto;
    }

    .modal-content {
      height: auto;
      max-height: calc(100vh - 48px);
    }
  }
`

export const meetingRoomModalDialogStyles = createMeetingRoomModalDialogStyles()

export const meetingRoomModalHeaderStyles = css`
  .modal-content {
    border-radius: 4px;
    border: none;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.16);
  }

  .modal-header {
    background-color: var(--primary);
    height: 53px;
    border-bottom: none;
    padding: 0 24px;
    border-radius: 4px 4px 0 0;
    display: flex;
    align-items: center;
    flex-shrink: 0;

    .btn-close {
      filter: brightness(0) invert(1);
      opacity: 1;
    }
  }

  .modal-title {
    font-size: 20px;
    font-weight: 400;
    color: var(--white);
    margin: 0;
    line-height: 1.2;

    @media (max-width: 575px) {
      font-size: 16px;
    }
  }
`
